import React from "react";
import {Link, Typography, makeStyles} from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    '& > div': {
      marginTop: theme.spacing(2)
    },
    color: 'white',
    textAlign: 'center'
  },
  text: {
    fontSize: '0.8rem',
    textTransform: 'uppercase',
    color: 'white'
  }
}));

export const Footer = ({ name = 'more', referral = "https://www.growthhub.com/?gclid=salegrid.com&gbraid=salegrid.com&wbraid=salegrid.com" }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.text}>
        <Link
          style={{ color: 'white' }}
          href={referral}
          target="_blank">
          Looking for {name.toLowerCase()} leads?
        </Link>
        &nbsp;-&nbsp;
        <Link
          style={{ color: 'white' }}
          href="https://rocketcloud.com"
          target="_blank">
          Cold Leads
        </Link>
        &nbsp;-&nbsp;
        <Link
          style={{ color: 'white' }}
          href="/pages/privacy/"
          target="_blank">
          Privacy Policy
        </Link>
        &nbsp;-&nbsp;
        <Link
          style={{ color: 'white' }}
          href="/pages/terms/"
          target="_blank">
          Terms of Use
        </Link>
        &nbsp;-&nbsp;
        <Link
          style={{ color: 'white' }}
          href="/pages/opout/"
          target="_blank">
          Do Not Sell My Personal Information
        </Link>
        &nbsp;-&nbsp;
        <Link
          style={{ color: 'white' }}
          href="/pages/contact/"
          target="_blank">
          Contact
        </Link>
      </div>
      <div>
        <Typography className={classes.text}>
          &copy; {new Date().getFullYear()} SaleGrid.com. All Rights Reserved.
        </Typography>
      </div>
    </div>
  );
};
